module.exports = __webpack_public_path__ + "static/media/deco2.a6c80e42.svg";